module.exports = __webpack_public_path__ + "img/art_2_4.652b5d0f.jpeg";